import { inject as i, provide as t } from "vue";
let o = Symbol("Context");
var l = ((n) => (n[n.Open = 1] = "Open", n[n.Closed = 2] = "Closed", n[n.Closing = 4] = "Closing", n[n.Opening = 8] = "Opening", n))(l || {});
function r() {
  return i(o, null);
}
function C(n) {
  t(o, n);
}
export {
  l as i,
  r as l,
  C as t
};
//# sourceMappingURL=open-closed-BXrToqAS.mjs.map
